import { ChangeEmailModel } from './change-email.model';
import MESSAGES from './change-email.messages';
import { formatMessage } from 'src/api/localize';

export const changeEmailFormData = (): ChangeEmailModel => ({
  email: {
    col: 12,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.newEmailError}),
    label: formatMessage({...MESSAGES.newEmailText}),
    name: 'email',
    type: 'email',
    placeholder: formatMessage({...MESSAGES.newEmailText}),
    required: true,
    validation: 'isEmail',
    value: '',
  }
});
